module.exports = __webpack_public_path__ + "static/media/breadfriend-logo.8eb987ba.svg";